import Vue from 'vue';
import Vuex from "vuex";


Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    userName: "",
    isLoggedIn: false,
    user: {},
    currentProcess: "",
    currentCompany: "",
    userRole: "",
    sip: 0,
    currentCollection: "",
    currentPriority: "",
    form: {},
    searchResult: []
  },
  actions: {
    login: function ({ commit }, user) {
      commit("LOGIN_SUCCESS", user);
    },
    logout: function ({ commit }) {
      commit("LOGOUT");
    },
    setProcess: function ({ commit }, obj) {
      commit("SET_PROCESS", obj);
    },
    setCollection: function ({ commit }, obj) {
      commit("SET_COLLECTION", obj);
    },
    setSearchResult: function ({ commit }, result) {
      commit('SET_SEARCH_RESULT', result);
    }
  },
  mutations: {
    LOGIN_SUCCESS: function (state, user) {
      state.isLoggedIn = true;
      state.user = user.user;
    },
    LOGOUT: function (state) {
      state.isLoggedIn = false;
      state.user = {};
      state.currentProcess = "";
      state.userRole = "";
    },
    SET_PROCESS: function (state, obj) {
      state.currentProcess = obj.process;
      state.userRole = obj.userRole;
      state.currentCompany = obj.companyName;
      state.sip = obj.sip;
    },
    SET_COLLECTION: function (state, obj) {
      state.currentCollection = obj.collection;
      state.currentPriority = obj.priority;
      state.form = obj.form;
    },
    SET_SEARCH_RESULT: function (state, result) {
      state.searchResult = result;
    }
  },
  getters: {
    isLoggedIn: state => {
      return state.isLoggedIn;
    },
    loggedUser: state => {
      return state.user;
    },
    currentCompany: state => {
      return state.currentCompany;
    },
    currentProcess: state => {
      return state.currentProcess;
    },
    userRole: state => {
      return state.userRole;
    },
    currentCollection: state => {
      return state.currentCollection;
    },
    currentPriority: state => {
      return state.currentPriority;
    },
    getForm: state => {
      return state.form;
    },
    getSip: state => {
      return state.sip;
    },
    getSearchResult: state => {
      return state.searchResult;
    }
  }
});

export default store;